import { atom } from "jotai";

/**
 * Atom to track whether the questionnaire form is currently being submitted.
 * Set to true when form submission starts, false when complete or on error.
 * Used by useShouldBlockSubmission to disable submit buttons during submission.
 */
export const isSubmittingFormAtom = atom<boolean>(false);
